// Meta Pixel (Facebook Pixel) Integration
// Pixel ID: 558825739910859

const PIXEL_ID = '558825739910859';

// Initialize Meta Pixel
export const initMetaPixel = () => {
  if (typeof window === 'undefined') return;
  
  // Check if already initialized
  if (window.fbq) return;

  // Meta Pixel base code
  (function(f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function() {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

  // Initialize with Pixel ID
  window.fbq('init', PIXEL_ID);
  
  // Track PageView on init
  window.fbq('track', 'PageView');
  
  console.log('Meta Pixel initialized:', PIXEL_ID);
};

// Track PageView event
export const trackPageView = () => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'PageView');
  }
};

// Track ViewContent event (when user views a product/content)
export const trackViewContent = (contentName, contentCategory, value) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'ViewContent', {
      content_name: contentName,
      content_category: contentCategory,
      value: value,
      currency: 'BRL'
    });
  }
};

// Track Lead event (when user shows interest - clicks CTA, fills form, etc)
export const trackLead = (contentName, source) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'Lead', {
      content_name: contentName,
      content_category: 'Cevadores Personalizados',
      lead_source: source
    });
  }
};

// Track Contact event (when user initiates contact via WhatsApp)
export const trackContact = (method) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'Contact', {
      contact_method: method
    });
  }
};

// Track AddToCart event (when user starts building their order)
export const trackAddToCart = (contentName, value, quantity) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: contentName,
      content_category: 'Cevadores Personalizados',
      value: value,
      currency: 'BRL',
      quantity: quantity
    });
  }
};

// Track InitiateCheckout event
export const trackInitiateCheckout = (value, numItems) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'InitiateCheckout', {
      content_category: 'Cevadores Personalizados',
      value: value,
      currency: 'BRL',
      num_items: numItems
    });
  }
};

// Track custom event
export const trackCustomEvent = (eventName, params = {}) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('trackCustom', eventName, params);
  }
};

// Get Pixel ID (useful for debugging)
export const getPixelId = () => PIXEL_ID;
